export default "__VITE_ASSET__wt4J$rhQ__"